import type {
  Profile,
  Experience,
  Education,
  Skill,
  Certificate,
} from "@/types/database";

export type CVData = {
  profile: Profile;
  experiences: Experience[];
  education: Education[];
  skills: Skill[];
  certificates: Certificate[];
};

export type CVTemplateId = "modern" | "minimal" | "classic" | "tech";

export type CVTemplateMeta = {
  id: CVTemplateId;
  name: string;
  description: string;
  preview?: string;
};

export const CV_TEMPLATES: CVTemplateMeta[] = [
  {
    id: "modern",
    name: "Modern",
    description: "Phong cách hiện đại với tông màu xanh navy, thanh lịch",
  },
  {
    id: "minimal",
    name: "Minimal",
    description: "Tối giản, sạch sẽ, tối đa khoảng trắng",
  },
  {
    id: "classic",
    name: "Classic",
    description: "Truyền thống, trang trọng, phù hợp công ty lớn",
  },
  {
    id: "tech",
    name: "Tech",
    description: "Phong cách developer, nổi bật với accent màu",
  },
];
